<script>
import { Bar } from "vue-chartjs";
import { Chart } from 'chart.js'
import ResultModel from "@/models/modus/ResultModel";
import {
  soil_nutrient_elements,
  soil_nutrient_element_thresholds
} from "@/shared/result-table-fields";
import plugin from './SoilChartPlugin';

/*
  By default chartJS creates the chart with a transparent background
  We will need to register a plugin that will set the background for us.
  This import method is what is needed for the vue implementation of plugin registration
*/
Chart.plugins.register(plugin);

export default {
  name: "SoilNutrientsChart",
  extends: Bar,
  props: {
    result: {
      type: Object,
      default: () => new ResultModel()
    },
    results_total: {
      type: Object,
      default: () => null
    }
  },
  data: () => ({
    chartdata: {
      labels: soil_nutrient_elements.map(i => i.element),
      datasets: [
        {
          label: "Deficient",
          backgroundColor: "red",
          //data: [90,100,100,100],
          data: []
        },
        {
          label: "Low",
          backgroundColor: "blue",
          //data: [0,20,100,40],
          data: []
        },
        {
          label: "Optimum",
          backgroundColor: "green",
          //data: [0,0,100,0],
          data: []
        },
        {
          label: "Excess",
          backgroundColor: "purple",
          //data: [0,0,100,0],
          data: []
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      tooltips: {
        callbacks: {
          label(tooltipItem) {
            if (tooltipItem.datasetIndex === 3) {
              return "Excess";
            } else if (tooltipItem.datasetIndex === 2) {
              return "Optimum";
            } else if (tooltipItem.datasetIndex === 1) {
              return "Low";
            } else {
              return "Deficient";
            }
          }
        }
      },
      scales: {
        xAxes: [
          {
            stacked: true
          }
        ],
        yAxes: [
          {
            stacked: true,
            gridLines: {},
            ticks: {
              stepSize: 50,
              callback(value) {
                if (value === 350) {
                  return "Excess";
                } else if (value === 250) {
                  return "Optimum";
                } else if (value === 150) {
                  return "Low";
                } else if (value === 50) {
                  return "Deficient";
                } else {
                  return "";
                }
              }
            },
          }
        ]
      }
    }
  }),
  methods: {
    resultCompiled() {
      this.result.compiled().then(compiled => {
        if (
          compiled &&
          compiled.result_events &&
          Object.keys(compiled.result_events).length
        ) {
          let event =
            compiled.result_events[Object.keys(compiled.result_events)[0]];
          if (event && event.totals && event.totals.soil_nutrients) {
            let t_macros = event.totals.soil_nutrients.macros;
            let t_secondary = event.totals.soil_nutrients.secondary;
            let t_micros = event.totals.soil_nutrients.micros;
            let t_compiled = { ...t_macros, ...t_secondary, ...t_micros };
            soil_nutrient_element_thresholds.forEach(i => {
              let value =
                t_compiled[i.element] && t_compiled[i.element].value
                  ? t_compiled[i.element].value
                  : null;
              let min = 0;
              i.thresholds.forEach((max, t_i) => {
                this.setChartdata(t_i, min, max, value);
                min = max;
              });
            });
          }
        }
        this.renderChart(this.chartdata, this.options);
      });
    },
    renderRawResult() {
      // take the results_total prop and loop through each of the analytes
      this.results_total.analytes.forEach((v, index) => {
        
        // get the current threshold
        const threshold = soil_nutrient_element_thresholds[index];

        // if the threshold element is not the same name as the current result analytes return out
        if (threshold.element !== v.name) {
          return;
        }

        // set the value and make sure it is an integer
        let value = parseInt(v.result)
        // set the defaul min 0;
        let min = 0;
        // loop through all the threshold values within the threshold object
        threshold.thresholds.forEach((max, t_i) => {
          // set the chart data with the given data
          this.setChartdata(t_i, min, max, value);
          // update the min value to be the max value
          min = max;
        })
      });

      // render the chart
      this.renderChart(this.chartdata, this.options);
    },
    setChartdata(index, min, max, value) {
      if (!value || !max) {
        this.chartdata.datasets[index].data.push(0);
      } else if (value > max) {
        this.chartdata.datasets[index].data.push(100);
      } else if (value < min) {
        this.chartdata.datasets[index].data.push(0);
      } else {
        this.chartdata.datasets[index].data.push(
          Math.round(((value - min) / (max - min)) * 100)
        );
      }
    }
  },
  mounted() {
    if (!this.results_total) {
      this.resultCompiled();
    } else {
      this.renderRawResult();
    }
  }
};
</script>
